import script from "./YoutubeRankingSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./YoutubeRankingSlider.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/style/mainpage.css?vue&type=style&index=0&id=2794e35d&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2794e35d"]])

export default __exports__